import { mapActions } from 'vuex';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import popupPageModeMixin from '@/mixins/popupPageModeMixin';
import { withMeta } from '@/helpers/dataLayer';

export default {
  mixins: [
    popupPageModeMixin,
  ],
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    onLogin() {
      this.$gtm.trackEvent(withMeta({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'click',
        label: 'Login to My Account',
      }));
      if (this.isPage) {
        this.$router.push({ name: 'account-page-login' });
      } else {
        this.setCurrentPopup(MODALS.LOGIN);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-register/footer/footer.js